import type { SearchMetadata } from "@/lib/search-metadata-store";
import type { StoredSearchQuery } from "@/lib/shopper-search";

/**
 * The query chat metadata holds when it carries no agent intent (a curated
 * rail's stored query): its words, filters and style tuning.
 */
export function storedQueryFromMetadata(metadata: SearchMetadata): StoredSearchQuery {
  return {
    text: metadata.query,
    facets: metadata.facets,
    price_min: metadata.priceMin,
    price_max: metadata.priceMax,
    similar_to_brands: metadata.similarToBrands,
    ranking_embedding_columns: metadata.rankingEmbeddingColumns,
    retrieval_embedding_columns: metadata.retrievalEmbeddingColumns,
  };
}
